import { NotificationProviderScope } from "./interface";
import { getNotificationProvider } from "./provider";
export const registerNotificationBackend = (backend, scope) => {
    const globalProvider = getNotificationProvider();
    if (!scope || scope === NotificationProviderScope.Global) {
        backend.initProvider(globalProvider);
    }
    else {
        globalProvider.registerBackend(scope, backend);
    }
};
//# sourceMappingURL=backend.js.map
